import { Methods } from "../enums/Methods";

export const FeedMethods = [
  Methods.EB_Feed,
  Methods.Media_Exchange_96w,
  Methods.Media_Exchange_12_24w,
  Methods.Lynx_384_Variable_Feed,
];
